

import React, { useState } from "react";
import Application from "./Application";
import Axios from "axios";
import { apiurl } from "../../../path";

// const AdminState = (props) => {
//   try {
//     let token = localStorage.getItem("Token");

//     const Usermenu = async () => {
//       try {
//         let data = await fetch(apiurl + "/GetMenu", {
//           method: "POST",
//           headers: { "Content-Type": "Application/json", AuthToken: token },
//           body: JSON.stringify(),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in Usermenu:", error);
//       }
//     };

//     const SearchWinner = async (Auction_ID) => {
//       try {
//         let data = await fetch(apiurl + "/Admin/GetWinnerList", {
//           method: "POST",
//           headers: { "Content-Type": "Application/json", AuthToken: token },
//           body: JSON.stringify({ Auction_ID: Auction_ID }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in SearchWinner:", error);
//       }
//     };

//     const Organisation = async (searchPattern) => {
//       try {
//         let data = await fetch(apiurl + "/Organisation", {
//           method: "POST",
//           headers: { "Content-Type": "Application/json", AuthToken: token },
//           body: JSON.stringify({ searchPattern: searchPattern }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in Organisation:", error);
//       }
//     };

//     const GetPaymentTable = async (para) => {
//       try {
//         let data = await fetch(apiurl + "/PaymentTable", {
//           method: "POST",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//           body: JSON.stringify({ Para: para }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in PaymentTable:", error);
//       }
//     };

//     const RefundTaxData = async (para) => {
//       try {
//         let data = await fetch(apiurl + "/RefundCheck", {
//           method: "POST",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//           body: JSON.stringify({ Tender_ID: para }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in PaymentTable:", error);
//       }
//     };

//     const GetBillFiles = async () => {
//       try {
//         let data = await fetch(apiurl + "/BillFiles", {
//           method: "POST",
//           headers: { AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetRefundFiles:", error);
//       }
//     };

//     const GetAdminPassKeys = async () => {
//       try {
//         let data = await fetch(apiurl + "/AdminPassKeys", {
//           method: "GET",
//           headers: { AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetAdminPassKeys:", error);
//       }
//     };

//     const AddAdminPassKeys = async (adminpasskeysdata) => {
//       try {
//         let data = await fetch(apiurl + "/AddAdminPassKeys", {
//           method: "POST",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//           body: JSON.stringify({ ...adminpasskeysdata }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in AddAdminPassKeys:", error);
//       }
//     };

//     const DeleteAdminPassKeys = async (e) => {
//       try {
//         let data = await fetch(apiurl + "/DeleteAdminPassKeys", {
//           method: "DELETE",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//           body: JSON.stringify({ ...e }),
//         });
//       } catch (error) {
//         console.error("Error in DeleteAdminPassKeys:", error);
//       }
//     };

//     const GetOpenTenders = async () => {
//       try {
//         let data = await fetch(apiurl + "/OpenTenders", {
//           method: "GET",
//           headers: { AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetOpenTenders:", error);
//       }
//     };

//     const GetClosedTenders = async (searchdate) => {
//       try {
//         let data = await fetch(apiurl + "/ClosedTenders", {
//           method: "POST",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//           body: JSON.stringify({ ...searchdate }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetClosedTenders:", error);
//       }
//     };

//     const GetAuctionsList = async (type, searchPattern) => {
//       try {
//         let data = await fetch(apiurl + "/Admin/Auctions", {
//           method: "POST",
//           headers: { "Content-Type": "Application/json", AuthToken: token },
//           body: JSON.stringify({ type: type, searchPattern: searchPattern }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetAuctionsList:", error);
//       }
//     };
//     const EditAuction = async (formdata) => {
//       try {
//         let data = await fetch(apiurl + "/Admin/Auctions", {
//           method: "POST",
//           headers: { AuthToken: token },
//           body: formdata,
//         });
//         data = await data.json();
//         console.log(data);
//         return data;
//       } catch (error) {
//         console.error("Error in EditAuction:", error);
//       }
//     };
//     const CreateAuction = async (formdata, EToken) => {
//       try {
//         let data = await fetch(apiurl + "/Admin/CreateAuction", {
//           method: "POST",
//           headers: { AuthToken: token },
//           body: formdata,
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in CreateAuction:", error);
//       }
//     };

//     const AuctionWinnerDeclartionGet = async () => {
//       try {
//         let data = await fetch(apiurl + "/Admin/AuctionWinnerDeclartion", {
//           method: "POST",
//           headers: { AuthToken: token },
//           body: {},
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in AuctionWinnerDeclartionGet:", error);
//       }
//     };

//     const GetWinnerDeclare = async (id) => {
//       try {
//         let data = await fetch(apiurl + "/Admin/GetWinnerDeclare", {
//           method: "POST",
//           headers: { "Content-Type": "Application/json", AuthToken: token },
//           body: JSON.stringify({ id: id }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetWinnerDeclare:", error);
//       }
//     };

//     const MakeWinner = async (formdata) => {
//       try {
//         let data = await fetch(apiurl + "/Admin/MakeWinner", {
//           method: "POST",
//           headers: { AuthToken: token },
//           body: formdata,
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in MakeWinner:", error);
//       }
//     };
//     const ReverseWinner = async (formdata) => {
//       try {
//         let data = await fetch(apiurl + "/Admin/ReverseWinner", {
//           method: "POST",
//           headers: { "Content-Type": "Application/json", AuthToken: token },
//           body: JSON.stringify({ ...formdata }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in ReverseWinner:", error);
//       }
//     };

//     const WinnerCrudOperations = async (type, id, form) => {
//       try {
//         if (type === "GetData") {
//           let data = await fetch(apiurl + "/Admin/WinnerCrudOperations", {
//             method: "POST",
//             headers: { "Content-Type": "Application/json", AuthToken: token },
//             body: JSON.stringify({ type: type, Auction_ID: id }),
//           });
//           data = await data.json();
//           return data;
//         }
//         if (type === "update") {
//           let data = await fetch(apiurl + "/Admin/WinnerCrudOperations", {
//             method: "POST",
//             headers: { "Content-Type": "Application/json", AuthToken: token },
//             body: JSON.stringify({
//               type: type,
//               ...form,
//             }),
//           });
//           data = await data.json();
//           return data;
//         }
//       } catch (error) {
//         console.error("Error in WinnerCrudOperations:", error);
//       }
//     };

//     const ShowAuctions = async (type, item) => {
//       try {
//         // if (item) {
//         //     let data = await Axios.post('http://' + apiurl + '/GetAuctions/ShowAuctions', { type: type, searchPattern: item }, {
//         //         headers: {
//         //             'Content-Type': 'Application/json'
//         //         }
//         //     }).then(response => {
//         //         return response.data
//         //     }).catch(err => {
//         //         console.log(err)
//         //     })
//         //     return data
//         // }
//         // let data = await Axios.post('http://' + apiurl + '/GetAuctions/ShowAuctions', { type: type }, {
//         //     headers: {
//         //         'Content-Type': 'Application/json'
//         //     }
//         // }).then(response => {
//         //     return response.data
//         // }).catch(err => {
//         //     console.log(err)
//         // })
//         // return data
//       } catch (error) {
//         console.error("Error in ShowAuctions:", error);
//       }
//     };

//     const EcsRefund = async (method) => {
//       if (method === "LoserRefund") {
//         try {
//           let refund = await Axios.post(
//             apiurl + "/Admin/EcsRefund",
//             { method: method },
//             {
//               headers: {
//                 "Content-Type": "Application/json",
//                 AuthToken: token,
//               },
//             },
//           )
//             .then((response) => {
//               return response.data;
//             })
//             .catch((e) => {
//               console.log(e);
//             });
//           return refund;
//         } catch (error) {
//           console.error("Error in EcsRefund:", error);
//         }
//       }
//       if (method === "TenderCancelRefund") {
//         try {
//           let refund = await Axios.post(
//             apiurl + "/Admin/EcsRefund",
//             { method: method },
//             {
//               headers: {
//                 "Content-Type": "Application/json",
//                 AuthToken: token,
//               },
//             },
//           )
//             .then((response) => {
//               return response.data;
//             })
//             .catch((e) => {
//               console.log(e);
//             });
//           return refund;
//         } catch (error) {
//           console.error("Error in EcsRefund:", error);
//         }
//       } else {
//         try {
//           let refund = await Axios.post(
//             apiurl + "/Admin/EcsRefund",
//             {},
//             {
//               headers: {
//                 "Content-Type": "Application/json",
//                 AuthToken: token,
//               },
//             },
//           )
//             .then((response) => {
//               return response.data;
//             })
//             .catch((e) => {
//               console.log(e);
//             });
//           return refund;
//         } catch (error) {
//           console.error("Error in EcsRefund:", error);
//         }
//       }
//     };

//     const GenerateRefund = async (type, Auctionid) => {
//       try {
//         let refund = await Axios.post(
//           apiurl + "/Admin/GenerateRefund",
//           { type: type, Auctionid: Auctionid },
//           {
//             headers: {
//               "Content-Type": "Application/json",
//               AuthToken: token,
//             },
//           },
//         )
//           .then((response) => {
//             return response.data;
//           })
//           .catch((e) => {
//             console.log(e);
//           });
//         return refund;
//       } catch (error) {
//         console.error("Error in GenerateRefund:", error);
//       }
//     };
//     const EcsUpload = async (data, id, AuctionName) => {
//       try {
//         let refund = await Axios.post(
//           apiurl + "/Admin/EcsUploadfile",
//           {
//             data: data,
//             AuctionId: id,
//             AuctionName: AuctionName,
//           },
//           {
//             headers: {
//               "Content-Type": "Application/json",
//               AuthToken: token,
//             },
//           },
//         )
//           .then((response) => {
//             return response.data;
//           })
//           .catch((e) => {
//             console.log(e);
//           });
//         return refund;
//       } catch (error) {
//         console.error("Error in EcsUpload:", error);
//       }
//     };
//     const ShowRegisteredAuctionUser = async (id) => {
//       try {
//         let refund = await Axios.post(
//           apiurl + "/Admin/ShowRegisteredAuctionUser",
//           {
//             AuctionId: id,
//           },
//           {
//             headers: {
//               "Content-Type": "Application/json",
//               AuthToken: token,
//             },
//           },
//         )
//           .then((response) => {
//             console.log(response.data);
//             return response.data;
//           })
//           .catch((e) => {
//             console.log(e);
//           });
//         return refund;
//       } catch (error) {
//         console.error("Error in ShowRegisteredAuctionUser:", error);
//       }
//     };

//     const CompleteRefundProcess = async (Auctionid) => {
//       try {
//         let refund = await Axios.post(
//           apiurl + "/Admin/CompleteRefundProcess",
//           {
//             AuctionId: Auctionid,
//           },
//           {
//             headers: {
//               "Content-Type": "Application/json",
//               AuthToken: token,
//             },
//           },
//         )
//           .then((response) => {
//             return response.data;
//           })
//           .catch((e) => {
//             console.log(e);
//           });
//         return refund;
//       } catch (error) {
//         console.error("Error in CompleteRefundProcess:", error);
//       }
//     };

//     const SendRefund = async (Data, id, tendername, textToSave, EToken) => {
//       try {
//         let refund = await Axios.post(
//           apiurl + "/AdminRefund/RefundHash",
//           {
//             csvdata: Data,
//             Tender_ID: id,
//             Tender_Name: tendername,
//             textToSave: textToSave,
//           },
//           {
//             headers: {
//               "Content-Type": "Application/json",
//               AuthToken: token,
//               EToken: EToken,
//             },
//           },
//         )
//           .then((response) => {
//             return response.data;
//           })
//           .catch((e) => {
//             console.log(e);
//           });
//         return refund;
//       } catch (error) {
//         console.error("Error in SendRefund:", error);
//       }
//     };

//     const EmployeeManagement = async (type, data) => {
//       try {
//         if (type === "Create") {
//           let Creation = await fetch(
//             apiurl + "/EmployeeManagement/CreateEmployee",
//             {
//               method: "post",
//               headers: { "Content-Type": "Application/json", AuthToken: token },
//               body: JSON.stringify({ ...data, type }),
//             },
//           );
//           Creation = await Creation.json();
//           return Creation;
//         }
//         if (type === "Update") {
//           let Creation = await fetch(
//             apiurl + "/EmployeeManagement/CreateEmployee",
//             {
//               method: "post",
//               headers: { "Content-Type": "Application/json", AuthToken: token },
//               body: JSON.stringify({ ...data, type }),
//             },
//           );
//           Creation = await Creation.json();
//           if (Creation) {
//             alert("Successfully Edited");
//           } else {
//             alert("failed Edition");
//           }
//         } else if (type === "View") {
//           let Creation = await fetch(
//             apiurl + "/EmployeeManagement/CreateEmployee",
//             {
//               method: "post",
//               headers: { "Content-Type": "Application/json", AuthToken: token },
//               body: JSON.stringify({ Searchparameter: data, type: "View" }),
//             },
//           );
//           Creation = await Creation.json();
//           return Creation;
//         }
//       } catch (error) {
//         console.error("Error in EmployeeManagement:", error);
//       }
//     };

//     const Roles = async (type, data, obj) => {
//       try {
//         if (type === "View") {
//           let Creation = await fetch(apiurl + "/EmployeeManagement/Roles", {
//             method: "post",
//             headers: { "Content-Type": "Application/json", AuthToken: token },
//             body: JSON.stringify({ type: "View" }),
//           });
//           Creation = await Creation.json();
//           return Creation;
//         } else if (type === "CreateRole") {
//           let Creation = await fetch(apiurl + "/EmployeeManagement/Roles", {
//             method: "post",
//             headers: { "Content-Type": "Application/json", AuthToken: token },
//             body: JSON.stringify({ ...data, type: "CreateRole", obj }),
//           });
//           Creation = await Creation.json();
//           console.log(Creation);
//           if (Creation) {
//             alert("Your Role has been Successfully Created");
//           }
//           return Creation;
//         }
//       } catch (error) {
//         console.error("Error in Roles:", error);
//       }
//     };

//     const DepartmentHandler = async (type, data, obj) => {
//       try {
//         if (type === "view") {
//           let Creation = await fetch(
//             apiurl + "/EmployeeManagement/Department",
//             {
//               method: "post",
//               headers: { "Content-Type": "Application/json", AuthToken: token },
//               body: JSON.stringify({ type: "view" }),
//             },
//           );
//           Creation = await Creation.json();
//           return Creation;
//         } else if (type === "insert") {
//           let Creation = await fetch(
//             apiurl + "/EmployeeManagement/Department",
//             {
//               method: "post",
//               headers: { "Content-Type": "Application/json", AuthToken: token },
//               body: JSON.stringify({
//                 Department_Name: data,
//                 type: type,
//                 Menu_Access: obj,
//               }),
//             },
//           );
//           Creation = await Creation.json();
//           if (Creation) {
//             alert("Your Department has been Successfully Created");
//           }
//           return Creation;
//         } else if (type === "delete") {
//           let Creation = await fetch(
//             apiurl + "/EmployeeManagement/Department",
//             {
//               method: "post",
//               headers: { "Content-Type": "Application/json", AuthToken: token },
//               body: JSON.stringify({
//                 Department_Name: data,
//                 type: type,
//               }),
//             },
//           );
//           Creation = await Creation.json();
//           if (Creation) {
//             alert("Department Deleted Successfully");
//           } else {
//             alert("Failed to Delete Department");
//           }
//           return Creation;
//         }
//       } catch (error) {
//         console.error("Error in DepartmentHandler:", error);
//       }
//     };

//     const EditRoleActions = async (type, RoleID, menu, menuset) => {
//       try {
//         let Creation = await fetch(apiurl + "/EmployeeManagement/EditRole", {
//           method: "post",
//           headers: { "Content-Type": "Application/json", AuthToken: token },
//           body: JSON.stringify({ type: type, RoleID: RoleID, menu, menuset }),
//         });
//         Creation = await Creation.json();
//         if (Creation === true) {
//           alert("Your Role Editation has been complete");
//         }
//         return Creation;
//       } catch (error) {
//         console.error("Error in EditRoleActions:", error);
//       }
//     };

//     const MisReports = async (obj) => {
//       try {
//         let data = await fetch(apiurl + "/VendorManagement/MisReports", {
//           method: "POST",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//           body: JSON.stringify(obj),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.log(error);
//       }
//     };
//     const CustomeReports = async (form) => {
//       try {
//         let data = await fetch(apiurl + "/GetAuctions/CustomeReports", {
//           method: "POST",
//           headers: { "Content-Type": "Application/json", AuthToken: token },
//           body: JSON.stringify({ ...form }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in CustomeReports:", error);
//       }
//     };
//     const WinnerRefund = async (form, EToken) => {
//       console.log(form);
//       console.log(EToken);

//       try {
//         let data = await fetch(apiurl + "/Admin/TenderWinnerRefund", {
//           method: "POST",
//           headers: { AuthToken: token, EToken: EToken },
//           body: form,
//         });
//         data = await data.json();
//         console.log("data", data);
//         return data;
//       } catch (error) {
//         console.error("Error in WinnerRefund:", error);
//       }
//     };

//     const DashboardReports = async (daterep) => {
//       try {
//         let data = await fetch(apiurl + "/GetAuctions/DashboardReports", {
//           method: "POST",
//           headers: { "Content-Type": "Application/json", AuthToken: token },
//           body: JSON.stringify({ date: daterep }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in DashboardReports:", error);
//       }
//     };

//     const CreateToken = async (fortoken) => {
//       try {
//         let data = await fetch(apiurl + "/Signature/CreateToken", {
//           method: "POST",
//           headers: { "Content-Type": "Application/json", AuthToken: token },
//           body: JSON.stringify({ fortoken: fortoken }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in CreateToken:", error);
//       }
//     };

//     const AuthorizationFiles = async (fortoken) => {
//       try {
//         let data = await fetch(apiurl + "/Signature/Authorization", {
//           method: "POST",
//           headers: { "Content-Type": "Application/json", AuthToken: token },
//           body: JSON.stringify({ fortoken: fortoken }),
//         });
//         data = await data.json();

//         return data;
//       } catch (error) {
//         console.error("Error in AuthorizationFiles:", error);
//       }
//     };

//     const Authorizationverify = async (Tender_ID, EToken) => {
//       try {
//         let data = await fetch(apiurl + "/Signature/Authorizationverify", {
//           method: "POST",
//           headers: {
//             "Content-Type": "Application/json",
//             AuthToken: token,
//             EToken: EToken,
//           },
//           body: JSON.stringify({ Tender_ID: Tender_ID }),
//         });
//         data = await data.json();

//         return data;
//       } catch (error) {
//         console.error("Error in Authorizationverify:", error);
//       }
//     };

//     const Authorizationreject = async (Tender_ID, EToken, Remark) => {
//       try {
//         let data = await fetch(apiurl + "/Signature/Authorizationreject", {
//           method: "POST",
//           headers: {
//             "Content-Type": "Application/json",
//             AuthToken: token,
//             EToken: EToken,
//           },
//           body: JSON.stringify({ Tender_ID: Tender_ID, Remark: Remark }),
//         });
//         data = await data.json();

//         return data;
//       } catch (error) {
//         console.error("Error in Authorizationreject:", error);
//       }
//     };

//     const ReUploadDocument = async (formdata) => {
//       try {
//         let data = await fetch(apiurl + "/Signature/ReUploadDocument", {
//           method: "POST",
//           headers: { AuthToken: token },
//           body: formdata,
//         });
//         data = await data.json();

//         return data;
//       } catch (error) {
//         console.error("Error in ReUploadDocument:", error);
//       }
//     };

//     const ReUploadCancelDocument = async (formdata) => {
//       try {
//         let data = await fetch(apiurl + "/Signature/ReUploadCancelDocument", {
//           method: "POST",
//           headers: { AuthToken: token },
//           body: formdata,
//         });
//         data = await data.json();

//         return data;
//       } catch (error) {
//         console.error("Error in ReUploadCancelDocument:", error);
//       }
//     };

//     const ApprovalRefund = async (Tender_ID) => {
//       try {
//         let data = await fetch(apiurl + "/AdminRefund/ApprovalRefund", {
//           method: "POST",
//           headers: { "Content-Type": "Application/json", AuthToken: token },
//           body: JSON.stringify({ Tender_ID: Tender_ID }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in ApprovalRefund:", error);
//       }
//     };

//     const GetVendors = async (UniqueID) => {
//       try {
//         if (UniqueID) {
//           let data = await fetch(
//             apiurl + "/VendorManagement/GetAllContractorList",
//             {
//               method: "POST",
//               headers: { "Content-Type": "Application/json", AuthToken: token },
//               body: JSON.stringify({ UniqueID }),
//             },
//           );
//           data = await data.json();
//           return data;
//         } else {
//           let data = await fetch(
//             apiurl + "/VendorManagement/GetAllContractorList",
//             {
//               method: "POST",
//               headers: { AuthToken: token },
//             },
//           );
//           data = await data.json();
//           return data;
//         }
//       } catch (error) {
//         console.error("Error in GetVendors:", error);
//       }
//     };
//     const GetReport = async () => {
//       console.log("called");

//       try {
//         let data = await fetch(apiurl + "/GetReport", {
//           method: "GET",
//           headers: { AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetReport:", error);
//       }
//     };

//     const AddBudget = async (Head, Fund, Approvals) => {
//       try {
//         let data = await fetch(apiurl + "/AddBudget", {
//           method: "POST",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//           body: JSON.stringify({ Head, Fund, Approvals }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in AddBudget:", error?.message || error);
//       }
//     };

//     const GetBudget = async () => {
//       try {
//         let data = await fetch(apiurl + "/GetBudget", {
//           method: "GET",
//           headers: { AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetBudget:", error?.message || error);
//       }
//     };

//     const UpdateBudget = async (id, updatedData) => {
//       console.log(updatedData);

//       try {
//         let data = await fetch(`${apiurl}/UpdateBudget`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//           body: JSON.stringify(updatedData),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in UpdateBudget:", error?.message || error);
//       }
//     };

//     const DeleteBudget = async (id) => {
//       console.log(id);

//       try {
//         let data = await fetch(`${apiurl}/DeleteBudget`, {
//           method: "POST",
//           headers: { "Content-Type": "Application/json", AuthToken: token },
//           body: JSON.stringify({ id }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in DeleteBudget:", error?.message || error);
//       }
//     };

//     const BankMaster = async (type, formData) => {
//       console.log("swapnil", type, formData);

//       try {
//         if (type == "get") {
//           let Creation = await fetch(apiurl + "/banks", {
//             method: "post",
//             headers: { "Content-Type": "Application/json", AuthToken: token },
//             body: JSON.stringify({ type: "get" }),
//           });
//           Creation = await Creation.json();
//           return Creation;
//         } else if (type == "insert") {
//           let Creation = await fetch(apiurl + "/banks", {
//             method: "post",
//             headers: { "Content-Type": "Application/json", AuthToken: token },
//             body: JSON.stringify({
//               ...formData,
//               type: type,
//             }),
//           });
//           Creation = await Creation.json();
//           return Creation;
//         } else if (type == "edit") {
//           let Creation = await fetch(apiurl + "/banks", {
//             method: "post",
//             headers: { "Content-Type": "Application/json", AuthToken: token },
//             body: JSON.stringify({
//               ...formData,
//               type: type,
//             }),
//           });
//           Creation = await Creation.json();
//           return Creation;
//         } else if (type == "delete") {
//           let Creation = await fetch(apiurl + "/banks", {
//             method: "post",
//             headers: { "Content-Type": "Application/json", AuthToken: token },
//             body: JSON.stringify({
//               id: formData,
//               type: type,
//             }),
//           });
//           Creation = await Creation.json();
//           return Creation;
//         }
//       } catch (error) {
//         console.error("Error in BankMaster:", error);
//       }
//     };

//     const UploadBills = async (formdata) => {
//       console.log(formdata);

//       try {
//         let data = await fetch(apiurl + "/VendorManagement/UploadBill", {
//           method: "POST",
//           headers: { AuthToken: token },
//           body: formdata,
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in UploadBills:", error);
//       }
//     };
//     const TaxData = async (type, formdata) => {
//       console.log("Formdata111", type, formdata);

//       try {
//         if (type === "get") {
//           let Creation = await fetch(apiurl + "/Taxes", {
//             method: "post",
//             headers: { "Content-type": "Application/json", AuthToken: token },
//             body: JSON.stringify({ type: "get" }),
//           });
//           Creation = await Creation.json();
//           return Creation;
//         } else if (type === "insert") {
//           console.log("insert");

//           let Creation = await fetch(apiurl + "/Taxes", {
//             method: "post",
//             headers: { "Content-type": "Application/json", AuthToken: token },
//             body: JSON.stringify({
//               ...formdata,
//               type: type,
//             }),
//           });
//           Creation = await Creation.json();
//           return Creation;
//         } else if (type === "edit") {
//           console.log("edit");
//           let Creation = await fetch(apiurl + "/Taxes", {
//             method: "post",
//             headers: { "Content-type": "Application/json", AuthToken: token },
//             body: JSON.stringify({ ...formdata, type: type }),
//           });
//           Creation = await Creation.json();
//           return Creation;
//         } else if (type === "delete") {
//           console.log("delete");
//           let Creation = await fetch(apiurl + "/taxes", {
//             method: "post",
//             headers: { "Content-type": "Application/json", AuthToken: token },
//             body: JSON.stringify({ type: type, ID: formdata }),
//           });
//           Creation = await Creation.json();
//           return Creation;
//         }
//       } catch (error) {
//         console.error("Error in TaxData:", error);
//         return { message: "failed", error };
//       }
//     };

//     const GetBills = async () => {
//       try {
//         let data = await fetch(apiurl + "/BillApprovals/GetBills", {
//           method: "POST",
//           headers: { AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetBills:", error);
//       }
//     };

//     const ApproveBills = async (selectedBills, type, remark) => {
//       try {
//         const response = await fetch(apiurl + "/BillApprovals/ApproveBills", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             AuthToken: token,
//           },
//           body: JSON.stringify({
//             selectedBills,
//             type,
//             remark,
//           }),
//         });

//         console.log("Status:", response.status);

//         const result = await response.json();
//         console.log("Response:", result);

//         return result;
//       } catch (error) {
//         console.error("ApproveBills Error:", error);
//         throw error;
//       }
//     };

//     const GetVendorBills = async () => {
//       try {
//         let data = await fetch(apiurl + "/VendorManagement/GetVendorBills", {
//           method: "POST",
//           headers: { AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetVendorBills:", error);
//       }
//     };

//     const GetTaxAmounts = async (type) => {
//       try {
//         let data = await fetch(apiurl + "/Dashboard/getTaxesAmount", {
//           method: "POST",
//           headers: { AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in getTaxes:", error);
//       }
//     };

//     const getTaxes = async () => {
//       try {
//         let data = await fetch(apiurl + "/getTaxes", {
//           method: "POST",
//           headers: { AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in getTaxes:", error);
//       }
//     };

//     const GetAgnecyWiseTaxAmount = async (type) => {
//       try {
//         let data = await fetch(apiurl + "/Dashboard/getAgnecyWiseTaxAmount", {
//           method: "POST",
//           headers: { AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in getTaxes:", error);
//       }
//     };

//     const GetAgencyWiseData = async (projectId, type) => {
//       try {
//         let data = await fetch(apiurl + "/Dashboard/getAgencyWiseData", {
//           method: "POST",
//           headers: { "Content-Type": "Application/json", AuthToken: token },
//           body: JSON.stringify({ projectId: projectId, type: type }),
//         });
//         let res = await data.json();
//         return res;
//       } catch (error) {
//         console.error("Error in GetAgencyWiseData:", error);
//       }
//     };
//     const getTaxAmountsByDate = async () => {
//       try {
//         let data = await fetch(apiurl + "/Dashboard/getTaxesAmountbyDate", {
//           method: "POST",
//           headers: { AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in getTaxAmounts:", error);
//       }
//     };

//     const GetLogReports = async () => {
//       try {
//         let data = await fetch(apiurl + "/GetLogReports", {
//           method: "POST",
//           headers: { AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetRefundFiles:", error);
//       }
//     };
//     const GetSteelRates = async () => {
//       try {
//         let data = await fetch(apiurl + "/GetSteelRates", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             AuthToken: token,
//           },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetSteelRates:", error);
//       }
//     };

//     const GetDateWiseData = async (projectId, type) => {
//       try {
//         let data = await fetch(apiurl + "/Dashboard/getDateWiseData", {
//           method: "POST",
//           headers: { "Content-Type": "Application/json", AuthToken: token },
//           body: JSON.stringify({ projectId: projectId, type: type }),
//         });
//         let res = await data.json();
//         return res;
//       } catch (error) {
//         console.error("Error in GetDateWiseData:", error);
//       }
//     };

//     const AddProduct = async (type, formData) => {
//       try {
//         if (type === "get") {
//           let response = await fetch(apiurl + "/Inventory/add_product", {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               AuthToken: token,
//             },
//             body: JSON.stringify({ type: "get" }),
//           });
//           const data = await response.json();
//           return data;
//         }

//         if (type === "insert") {
//           let response = await fetch(apiurl + "/Inventory/add_product", {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               AuthToken: token,
//             },
//             body: JSON.stringify({ ...formData, type }),
//           });
//           const data = await response.json();
//           return data;
//         }

//         if (type === "update") {
//           let response = await fetch(apiurl + "/Inventory/add_product", {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               AuthToken: token,
//             },
//             body: JSON.stringify({ ...formData, type: "update" }),
//           });
//           const data = await response.json();
//           return data;
//         }

//         if (type === "delete") {
//           let response = await fetch(apiurl + "/Inventory/add_product", {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               AuthToken: token,
//             },
//             body: JSON.stringify({ ID: formData.ID, type: "delete" }),
//           });
//           const data = await response.json();
//           return data;
//         }

//         return { message: "invalid request" };
//       } catch (error) {
//         console.error("Error in AddProduct:", error);
//         return { message: "failed", error };
//       }
//     };
//     const PurchaseList = async (type, formData) => {
//       try {
//         if (type === "get") {
//           let response = await fetch(apiurl + "/Inventory/PurchaseList", {
//             method: "POST",
//             headers: { "content-type": "application/json", AuthToken: token },
//             body: JSON.stringify({ type: "get" }),
//           });
//           const data = await response.json();
//           return data;
//         }

//         if (type === "insert") {
//           let response = await fetch(apiurl + "/Inventory/PurchaseList", {
//             method: "POST",
//             headers: { "content-Type": "application/json", AuthToken: token },
//             body: JSON.stringify({ ...formData, type }),
//           });
//           const data = await response.json();
//           return data;
//         }
//         if (type === "update") {
//           let response = await fetch(apiurl + "/Inventory/PurchaseList", {
//             method: "POST",
//             headers: { "content-type": "application/json", AuthToken: token },
//             body: JSON.stringify({ ...formData, type }),
//           });
//           const data = await response.json();
//           return data;
//         }
//         if (type === "delete") {
//           let response = await fetch(apiurl + "/Inventory/PurchaseList", {
//             method: "POST",
//             headers: { "Content-Type": "application/json", AuthToken: token },
//             body: JSON.stringify({ ID: formData.ID, type: "delete" }),
//           });
//           const data = await response.json();
//           return data;
//         }
//         return { message: "invalid request" };
//       } catch (error) {
//         return { message: "failed", error };
//       }
//     };
//     const getecsreponsefiles = async () => {
//       try {
//         let data = await fetch(apiurl + "/BillApprovals/GetEcsReposnseFiles", {
//           method: "POST",
//           headers: { AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in ProjectCreation:", error);
//         throw error;
//       }
//     };

//     const HeadCreation = async (forminf) => {
//       try {
//         let response = await fetch(
//           `${apiurl}/VendorManagement/BudgetHeadCreation`,
//           {
//             method: "POST",
//             headers: { AuthToken: token },
//             body: forminf,
//           },
//         );
//         let data = await response.json();
//         return data;
//       } catch (error) {
//         console.error("Error in HeadCreation:", error);
//         throw error;
//       }
//     };

//     const GetProjectInfo = async (ProjectID, type) => {
//       try {
//         let data = await fetch(`${apiurl}/VendorManagement/GetProjectInfo`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//           body: JSON.stringify({ ProjectID: ProjectID, type: type }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetProjectInfo:", error);
//       }
//     };

//     const DeductionOperation = async (deductionData, type) => {
//       try {
//         let data = await fetch(
//           `${apiurl}/VendorManagement/DeductionOperation`,
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json", AuthToken: token },
//             body: JSON.stringify({ deductionData: deductionData, type: type }),
//           },
//         );
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in DeductionOperation:", error);
//       }
//     };

//     const GetBudgetHeadInfo = async (HeadID, type, selectedDemandID = null) => {
//       try {
//         let data = await fetch(`${apiurl}/VendorManagement/GetBudgetHeadInfo`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//           body: JSON.stringify({
//             HeadID: HeadID,
//             type: type,
//             selectedDemandID: selectedDemandID,
//           }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetBudgetHeadInfo:", error);
//       }
//     };

//     const WorkOrderCreation = async (formData) => {
//       try {
//         let response = await fetch(
//           `${apiurl}/VendorManagement/WorkOrderCreation`,
//           {
//             method: "POST",
//             headers: { AuthToken: token },
//             body: formData,
//           },
//         );
//         const data = await response.json();
//         return data;
//       } catch (error) {
//         console.error("Error in WorkOrderCreation:", error);
//         throw error;
//       }
//     };

//     const BudgetEstimation = async (forminf) => {
//       try {
//         let res = await fetch(`${apiurl}/VendorManagement/BudgetEstimation`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//           body: JSON.stringify(forminf),
//         });
//         const data = await res.json();
//         return data;
//       } catch (err) {
//         console.log(err);
//       }
//     };

//     const DemandCreation = async (forminf) => {
//       console.log("DemandGeneration Called");
//       try {
//         let response = await fetch(
//           `${apiurl}/VendorManagement/DemandGeneration`,
//           {
//             method: "POST",
//             headers: { AuthToken: token },
//             body: forminf,
//           },
//         );

//         const data = await response.json();
//         return data;
//       } catch (error) {
//         console.error("Error in WorkOrderCreation:", error);
//         throw error;
//       }
//     };

//     const ReleaseFDUTF = async (formData) => {
//       try {
//         let response = await fetch(`${apiurl}/VendorManagement/ReleaseFDUTF`, {
//           method: "POST",
//           headers: { AuthToken: token },
//           body: formData,
//         });
//         const data = await response.json();
//         return data;
//       } catch (error) {
//         console.error("Error in ProjectCreation:", error);
//         throw error;
//       }
//     };

//     const ViewAllReleaseFDUTF = async () => {
//       try {
//         let response = await fetch(
//           `${apiurl}/VendorManagement/ViewAllReleaseFDUTF`,
//           {
//             method: "POST",
//             headers: { AuthToken: token },
//           },
//         );

//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }

//         // Parse the response body
//         const data = await response.json();
//         return data;
//       } catch (error) {
//         console.error("Fetch error:", error);
//         throw error;
//       }
//     };

//     const GetDemandApproval = async () => {
//       try {
//         let data = await fetch(`${apiurl}/VendorManagement/GetDemandApproval`, {
//           method: "GET",
//           headers: { AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetOpenTenders:", error);
//       }
//     };

//     const GetAllProjectList = async () => {
//       try {
//         let data = await fetch(apiurl + "/VendorManagement/GetAllProjectList", {
//           method: "POST",
//           headers: { AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetAllProjectList:", error);
//       }
//     };

//     const GetAllContractorList = async () => {
//       try {
//         let data = await fetch(
//           apiurl + "/VendorManagement/GetAllContractorList",
//           {
//             method: "POST",
//             headers: { AuthToken: token },
//           },
//         );
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetAllProjectList:", error);
//       }
//     };

//     const GetAllBudgetHeadList = async () => {
//       try {
//         let data = await fetch(
//           apiurl + "/VendorManagement/GetAllBudgetHeadList",
//           {
//             method: "POST",
//             headers: { AuthToken: token },
//           },
//         );
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetAllProjectList:", error);
//       }
//     };

//     const GetAllBudgetEstimationList = async () => {
//       try {
//         let data = await fetch(
//           apiurl + "/VendorManagement/GetAllBudgetEstimationList",
//           {
//             method: "POST",
//             headers: { AuthToken: token },
//           },
//         );
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetAllProjectList:", error);
//       }
//     };

//     const GetAllWorkOrderList = async () => {
//       try {
//         let data = await fetch(
//           apiurl + "/VendorManagement/GetAllWorkOrderList",
//           {
//             method: "POST",
//             headers: { AuthToken: token },
//           },
//         );
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetAllProjectList:", error);
//       }
//     };

//     const GetProjectTotal = async () => {
//       try {
//         let data = await fetch(apiurl + "/Dashboard/getTotalProject", {
//           method: "POST",
//           headers: { AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetProjectTotal:", error);
//       }
//     };
//     const GetTotalAmountAvailbaleInBank = async () => {
//       try {
//         let data = await fetch(apiurl + "/Dashboard/getTotalBalanceinBank", {
//           method: "POST",
//           headers: { AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetProjectTotal:", error);
//       }
//     };
//     const GetLiabilityTotal = async (type) => {
//       try {
//         let data = await fetch(apiurl + "/Dashboard/GetTotalLiabilities", {
//           method: "POST",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//           body: JSON.stringify({ type: type }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetProjectTotal:", error);
//       }
//     };

//     const FundAllomentOperation = async (type, formdata) => {
//       try {
//         let data = await fetch(apiurl + "/VendorManagement/FundAllotment", {
//           method: "POST",
//           headers: { "Content-Type": "Application/json", AuthToken: token },
//           body: JSON.stringify({ type: type, data: formdata }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetProjectTotal:", error);
//       }
//     };

//     const ProjectCreation = async (forminf) => {
//       try {
//         let response = await fetch(`${apiurl}/VendorManagement/CreateProject`, {
//           method: "POST",
//           headers: { AuthToken: token },
//           body: forminf,
//         });
//         const data = await response.json();
//         return data;
//       } catch (error) {
//         console.error("Error in ProjectCreation:", error);
//         throw error;
//       }
//     };
//     const GetObjectCodes = async () => {
//       const response = await fetch(
//         `${apiurl}/VendorManagement/getObjectCodes`,
//         {
//           method: "GET",
//           headers: { AuthToken: token },
//         },
//       ); // Adjust the endpoint as needed

//       if (!response.ok) {
//         throw new Error("Failed to fetch object codes");
//       }
//       return response.json();
//     };

//     // ✅ New Add function
//     const AddObjectCode = async (objectCode) => {
//       const response = await fetch(`${apiurl}/VendorManagement/addObjectCode`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           AuthToken: token,
//         },
//         body: JSON.stringify({ objectCode }),
//       });

//       if (!response.ok) {
//         throw new Error("Failed to add object code");
//       }

//       return response.json(); // Optionally return server response
//     };
//     const UpdateObjectCode = async (oldCode, objectCode) => {
//       const response = await fetch(
//         `${apiurl}/VendorManagement/updateObjectCode`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             AuthToken: token,
//           },
//           body: JSON.stringify({
//             oldObjectCode: oldCode,
//             newObjectCode: objectCode,
//           }),
//         },
//       );

//       if (!response.ok) throw new Error("Failed to update object code");
//       return response.json();
//     };

//     const DeleteObjectCode = async (id) => {
//       const response = await fetch(
//         `${apiurl}/VendorManagement/deleteObjectCode`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             AuthToken: token,
//           },
//           body: JSON.stringify({ id }),
//         },
//       );

//       if (!response.ok) throw new Error("Failed to delete object code");
//       return response.json();
//     };

//     const GetTotalEstimationForWorkOrder = async (
//       ProjectID,
//       BudgetHeadID,
//       type,
//     ) => {
//       try {
//         let data = await fetch(
//           `${apiurl}/VendorManagement/GetTotalEstimationForWorkOrder`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               AuthToken: token,
//             },
//             body: JSON.stringify({
//               ProjectID,
//               BudgetHeadID,
//               type,
//             }),
//           },
//         );

//         data = await data.json();
//         return data.total;
//       } catch (error) {
//         console.error("Error:", error);
//       }
//     };

//     const BudgetHeadApproval = async (id, type, remark) => {
//       try {
//         let data = await fetch(apiurl + "/BillApprovals/BudgetHeadApproval", {
//           method: "POST",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//           body: JSON.stringify({ id: id, type: type, remark: remark }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in BudgetHeadApproval:", error);
//       }
//     };

//     const GetBudgetHeadList = async () => {
//       try {
//         let data = await fetch(apiurl + "/BillApprovals/GetBudgetHeadList", {
//           method: "GET",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetBudgetHeadList:", error);
//       }
//     };

//     const ProjectApproval = async (id, type, remark) => {
//       try {
//         let data = await fetch(apiurl + "/BillApprovals/ProjectApproval", {
//           method: "POST",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//           body: JSON.stringify({ id: id, type: type, remark: remark }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in ProjectApproval:", error);
//       }
//     };

//     const GetProjectList = async () => {
//       try {
//         let data = await fetch(apiurl + "/BillApprovals/GetProjectList", {
//           method: "GET",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetProjectList:", error);
//       }
//     };

//     const BudgetEstimationApproval = async (id, type, remark) => {
//       try {
//         let data = await fetch(
//           apiurl + "/BillApprovals/BudgetEstimationApproval",
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json", AuthToken: token },
//             body: JSON.stringify({ id: id, type: type, remark: remark }),
//           },
//         );
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in BudgetEstimationApproval:", error);
//       }
//     };

//     const GetBudgetEstimationList = async () => {
//       try {
//         let data = await fetch(
//           apiurl + "/BillApprovals/GetBudgetEstimationList",
//           {
//             method: "GET",
//             headers: { "Content-Type": "application/json", AuthToken: token },
//           },
//         );
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetBudgetEstimationList:", error);
//       }
//     };

//     const ReleaseFromFinanceApproval = async (id, type, remark) => {
//       try {
//         let data = await fetch(
//           apiurl + "/BillApprovals/ReleaseFromFinanceApproval",
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json", AuthToken: token },
//             body: JSON.stringify({ id: id, type: type, remark: remark }),
//           },
//         );
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in ReleaseFromFinanceApproval:", error);
//       }
//     };

//     const GetReleaseFromFinanceList = async () => {
//       try {
//         let data = await fetch(
//           apiurl + "/BillApprovals/GetReleaseFromFinanceList",
//           {
//             method: "GET",
//             headers: { "Content-Type": "application/json", AuthToken: token },
//           },
//         );
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetReleaseFromFinanceList:", error);
//       }
//     };

//     const GetAllWorkOrderInward = async () => {
//       try {
//         let res = await fetch(`${apiurl}/BillApprovals/GetAllWorkOrderInward`, {
//           method: "GET",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//         });
//         let data = await res.json();
//         return data;
//       } catch (error) {
//         console.log(error);
//       }
//     };

//     const WorkManagementApproval = async (id, type) => {
//       try {
//         let data = await fetch(
//           apiurl + "/BillApprovals/WorkManagementApproval",
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json", AuthToken: token },
//             body: JSON.stringify({ id: id, type: type }),
//           },
//         );
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in WorkManagementApproval:", error);
//       }
//     };

//     const GetVendorBillsAndDeduction = async (DemandID) => {
//       try {
//         let data = await fetch(
//           apiurl + "/VendorManagement/GetVendorBillsAndDeduction",
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json", AuthToken: token },
//             body: JSON.stringify({ DemandID: DemandID }),
//           },
//         );
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetVendorBillsAndDeduction:", error);
//       }
//     };

//     const AgencyRegistration = async (AgencyData) => {
//       try {
//         let data = await fetch(
//           apiurl + "/VendorManagement/AgencyRegistration",
//           {
//             method: "POST",
//             headers: { "Content-Type": "Application/json", AuthToken: token },
//             body: JSON.stringify({ data: AgencyData }),
//           },
//         );
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in AgencyRegistration:", error);
//       }
//     };

//     const GetAgencyList = async () => {
//       try {
//         let data = await fetch(apiurl + "/VendorManagement/GetAllAgencyList", {
//           method: "GET",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetAgencyList:", error);
//       }
//     };

//     const CreateUser = async (type, data) => {
//       try {
//         let data = await fetch(apiurl + "/EmployeeManagement/CreateUser", {
//           method: "post",
//           headers: { "Content-Type": "Application/json", AuthToken: token },
//           body: JSON.stringify({ ...data, type }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in EmployeeManagement:", error);
//       }
//     };

//     const GetAllFundList = async () => {
//       try {
//         let data = await fetch(apiurl + "/BillApprovals/GetAllFundList", {
//           method: "GET",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetAllFundList:", error);
//       }
//     };
//     const FetchECSFiles = async () => {
//       const res = await fetch(apiurl + "/ECSReport/FetchECSFiles", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           AuthToken: token,
//         },
//       });
//       return res.json();
//     };
//     const FetchECSFilesForTransfer = async () => {
//       const res = await fetch(apiurl + "/ECSReport/FetchECSFilesForTransfer", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           AuthToken: token,
//         },
//       });
//       return res.json();
//     };

//     const FetchECSReport = async (FileName) => {
//       try {
//         let data = await fetch(apiurl + "/ECSReport/FetchECSReport", {
//           method: "POST",
//           headers: { "Content-Type": "Application/Json", AuthToken: token },
//           body: JSON.stringify({ fileName: FileName }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("error in FetchECSReport:", error);
//       }
//     };

//     const FetchECSDashboardReport = async (FileName) => {
//       try {
//         let data = await fetch(apiurl + "/ECSReport/FetchECSDashboardReport", {
//           method: "GET",
//           headers: { "Content-Type": "Application/Json", AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("error in FetchECSDashboardReport:", error);
//       }
//     };

//     const FetchFilesForUpdate = async (FileName) => {
//       try {
//         let data = await fetch(apiurl + "/ECSReport/FetchFilesForUpdate", {
//           method: "GET",
//           headers: { "Content-Type": "Application/Json", AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("error in FetchFilesForUpdate:", error);
//       }
//     };

//     const FundCreation = async (formdata) => {
//       try {
//         let response = await fetch(`${apiurl}/VendorManagement/FundCreation`, {
//           method: "POST",
//           headers: { AuthToken: token },
//           body: formdata,
//         });
//         return await response.json();
//         // return data;
//       } catch (error) {
//         console.error("Error in FundCreation:", error);
//         throw error;
//       }
//     };

//     const FundApproval = async (id, type, remark) => {
//       console.log("calledddd");

//       try {
//         let data = await fetch(apiurl + "/BillApprovals/FundApproval", {
//           method: "POST",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//           body: JSON.stringify({ id: id, type: type, remark: remark }),
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in FundApproval:", error);
//       }
//     };

//     const GetNewFundList = async () => {
//       try {
//         let data = await fetch(apiurl + "/BillApprovals/GetNewFundList", {
//           method: "GET",
//           headers: { "Content-Type": "application/json", AuthToken: token },
//         });
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetFundList:", error);
//       }
//     };

//     const GetNewFundOutwardList = async () => {
//       try {
//         let data = await fetch(
//           apiurl + "/VendorManagement/GetNewFundOutwardList",
//           {
//             method: "GET",
//             headers: { "Content-Type": "application/json", AuthToken: token },
//           },
//         );
//         data = await data.json();
//         return data;
//       } catch (error) {
//         console.error("Error in GetNewFundOutwardList:", error);
//       }
//     };
//     const CreateMapCoordinateforProject = async (type, formdata) => {
//       const response = await fetch(
//         `${apiurl}/VendorManagement/MapCoordinateforProject`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             AuthToken: token,
//           },
//           body: JSON.stringify({ type, formdata }),
//         },
//       );
//       console.log("Status :", response.status);
//       console.log("URL :", response.url);

//       const text = await response.text();

//       console.log("Response Text :", text);

//       try {
//         return JSON.parse(text);
//       } catch (err) {
//         console.log("Invalid JSON Response");
//         throw err;
//       }
//     };
//     const GetProgressReportList = async () => {
//       try {
//         const response = await fetch(
//           `${apiurl}/VendorManagement/GetProgressReportList`,
//           {
//             method: "GET",
//             headers: { "Content-Type": "application/json", AuthToken: token },
//           },
//         );
//         const result = await response.json();
//         return result;
//       } catch (error) {
//         console.log("GetProgressReportList Error :", error);
//         return {
//           Status: false,
//           Message: "Server Error",
//         };
//       }
//     };
//     //
//     const ApproveProgressReport = async (ids, type, remark) => {
//       try {
//         const response = await fetch(
//           `${apiurl}/VendorManagement/ApproveProgressReport`,
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json", AuthToken: token },
//             body: JSON.stringify({
//               IDs: ids,
//               type: type,
//               Remark: remark,
//             }),
//           },
//         );

//         const result = await response.json();
//         return result;
//       } catch (error) {
//         console.log("ApproveProgressReport Error :", error);
//         return { Status: false, Message: "Server Error" };
//       }
//     };

//     const GetProgressReportOutwardList = async () => {
//       try {
//         const response = await fetch(
//           `${apiurl}/VendorManagement/GetProgressReportOutwardList`,
//           {
//             method: "GET",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: sessionStorage.getItem("token"),
//               AuthToken: token,
//             },
//           },
//         );

//         const result = await response.json();

//         return result;
//       } catch (error) {
//         console.log("GetProgressReportList Error :", error);

//         return {
//           Status: false,
//           Message: "Server Error",
//         };
//       }
//     };

//     const GetAgencyDashboardData = async ({ agencyCode, projectId, type }) => {
//       try {
//         const response = await fetch(
//           apiurl + "/Dashboard/GetAgencyDashboardData",
//           {
//             method: "POST",
//             headers: { "Content-Type": "Application/json", AuthToken: token },
//             body: JSON.stringify({ agencyCode, projectId, type }),
//           },
//         );
//         const result = await response.json();
//         console.log("GetAgencyDashboardData RESPONSE:", result);
//         if (!result.success) {
//           console.error("GetAgencyDashboardData:", result.message);
//           return [];
//         }
//         return result.data || [];
//       } catch (error) {
//         console.error("GetAgencyDashboardData ERROR:", error);
//         return [];
//       }
//     };

//     // const GetProjectDashboardData = async (projectId, type,workOrderUID = "") => {
//     //   try {
//     //     console.log("api called projectdashboard");
//     //     const response = await fetch(
//     //       apiurl + "/Dashboard/GetProjectDashboardData",
//     //       {
//     //         method: "POST",
//     //         headers: {
//     //           "Content-Type": "Application/json",
//     //           AuthToken: token,
//     //         },
//     //         body: JSON.stringify({
//     //           projectId,
//     //           type,
//     //           workOrderUID
//     //         }),
//     //       },
//     //     );

//     //     return await response.json();
//     //   } catch (error) {
//     //     console.error("GetProjectDashboardData ERROR:", error);
//     //     return [];
//     //   }
//     // };

//      const GetProjectDashboardData = async (
//           projectId,
//           type,
//           workOrderUID = "",
//           scheme = "",
//           schemeProjectIds = [],
//         ) => {
//           try {
//             console.log("api called projectdashboard");
//             const response = await fetch(
//               apiurl + "/Dashboard/GetProjectDashboardData",
//               {
//                 method: "POST",
//                 headers: {
//                   "Content-Type": "Application/json",
//                   AuthToken: token,
//                 },
//                 body: JSON.stringify({
//                   projectId,
//                   type,
//                   workOrderUID,
//                   scheme,
//                   schemeProjectIds,
//                 }),
//               },
//             );
    
//             return await response.json();
//           } catch (error) {
//             console.error("GetProjectDashboardData ERROR:", error);
//             return [];
//           }
//         };
//     return (
//       <Application.Provider
//         value={{
//           GetProjectDashboardData,
//           GetAgencyDashboardData,
//           GetAgencyWiseData,
//           GetAgnecyWiseTaxAmount,
//           ApprovalRefund,
//           Authorizationverify,
//           Authorizationreject,
//           CreateToken,
//           DashboardReports,
//           WinnerRefund,
//           CustomeReports,
//           MisReports,
//           Roles,
//           EmployeeManagement,
//           SendRefund,
//           ReverseWinner,
//           RefundTaxData,
//           CompleteRefundProcess,
//           GenerateRefund,
//           EcsRefund,
//           ShowAuctions,
//           WinnerCrudOperations,
//           MakeWinner,
//           GetWinnerDeclare,
//           AuctionWinnerDeclartionGet,
//           EditAuction,
//           Usermenu,
//           SearchWinner,
//           Organisation,
//           GetPaymentTable,
//           GetBillFiles,
//           GetAdminPassKeys,
//           AddAdminPassKeys,
//           DeleteAdminPassKeys,
//           GetOpenTenders,
//           GetClosedTenders,
//           GetAuctionsList,
//           CreateAuction,
//           EcsUpload,
//           ShowRegisteredAuctionUser,
//           DepartmentHandler,
//           EditRoleActions,
//           AuthorizationFiles,
//           ReUploadDocument,
//           ReUploadCancelDocument,
//           GetVendors,
//           GetReport,
//           AddBudget,
//           GetBudget,
//           BankMaster,
//           UploadBills,
//           GetBills,
//           ApproveBills,
//           GetVendorBills,
//           TaxData,
//           UpdateBudget,
//           DeleteBudget,
//           GetTaxAmounts,
//           getTaxes,
//           getTaxAmountsByDate,
//           GetLogReports,
//           GetSteelRates,
//           GetDateWiseData,
//           AddProduct,
//           PurchaseList,
//           ProjectCreation,
//           HeadCreation,
//           GetProjectInfo,
//           GetBudgetHeadInfo,
//           WorkOrderCreation,
//           BudgetEstimation,
//           DemandCreation,
//           ReleaseFDUTF,
//           ViewAllReleaseFDUTF,
//           GetDemandApproval,
//           GetAllProjectList,
//           GetAllContractorList,
//           GetAllBudgetHeadList,
//           GetAllBudgetEstimationList,
//           GetAllWorkOrderList,
//           GetProjectTotal,
//           GetLiabilityTotal,
//           GetTotalAmountAvailbaleInBank,
//           FundAllomentOperation,
//           DeductionOperation,
//           GetObjectCodes,
//           AddObjectCode,
//           UpdateObjectCode,
//           DeleteObjectCode,
//           GetTotalEstimationForWorkOrder,
//           GetAllWorkOrderInward,
//           WorkManagementApproval,
//           BudgetHeadApproval,
//           GetBudgetHeadList,
//           ProjectApproval,
//           GetProjectList,
//           BudgetEstimationApproval,
//           GetBudgetEstimationList,
//           ReleaseFromFinanceApproval,
//           GetReleaseFromFinanceList,
//           GetVendorBillsAndDeduction,
//           AgencyRegistration,
//           GetAgencyList,
//           CreateUser,
//           GetAllFundList,
//           FetchECSFiles,
//           FetchECSReport,
//           FetchECSDashboardReport,
//           FetchFilesForUpdate,
//           FetchECSFilesForTransfer,
//           FundCreation,
//           FundApproval,
//           GetNewFundList,
//           GetNewFundOutwardList,
//           CreateMapCoordinateforProject,
//           GetProgressReportList,
//           ApproveProgressReport,
//           GetProgressReportOutwardList,
//         }}
//       >
//         {props.children}
//       </Application.Provider>
//     );
//   } catch (error) {
//     console.error("Error in AdminState:", error);
//     throw error;
//   }
// };





// commented on 12-09

const AdminState = (props) => {
  try {
    let token = localStorage.getItem("Token");

    const Usermenu = async () => {
      try {
        let data = await fetch(apiurl + "/GetMenu", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify(),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in Usermenu:", error);
      }
    };

    const SearchWinner = async (Auction_ID) => {
      try {
        let data = await fetch(apiurl + "/Admin/GetWinnerList", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ Auction_ID: Auction_ID }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in SearchWinner:", error);
      }
    };

    const Organisation = async (searchPattern) => {
      try {
        let data = await fetch(apiurl + "/Organisation", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ searchPattern: searchPattern }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in Organisation:", error);
      }
    };

    const GetPaymentTable = async (para) => {
      try {
        let data = await fetch(apiurl + "/PaymentTable", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ Para: para }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in PaymentTable:", error);
      }
    };

    const RefundTaxData = async (para) => {
      try {
        let data = await fetch(apiurl + "/RefundCheck", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ Tender_ID: para }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in PaymentTable:", error);
      }
    };

    const GetBillFiles = async () => {
      try {
        let data = await fetch(apiurl + "/BillFiles", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetRefundFiles:", error);
      }
    };

    const GetAdminPassKeys = async () => {
      try {
        let data = await fetch(apiurl + "/AdminPassKeys", {
          method: "GET",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAdminPassKeys:", error);
      }
    };

    const AddAdminPassKeys = async (adminpasskeysdata) => {
      try {
        let data = await fetch(apiurl + "/AddAdminPassKeys", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ ...adminpasskeysdata }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in AddAdminPassKeys:", error);
      }
    };

    const DeleteAdminPassKeys = async (e) => {
      try {
        let data = await fetch(apiurl + "/DeleteAdminPassKeys", {
          method: "DELETE",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ ...e }),
        });
      } catch (error) {
        console.error("Error in DeleteAdminPassKeys:", error);
      }
    };

    const GetOpenTenders = async () => {
      try {
        let data = await fetch(apiurl + "/OpenTenders", {
          method: "GET",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetOpenTenders:", error);
      }
    };

    const GetClosedTenders = async (searchdate) => {
      try {
        let data = await fetch(apiurl + "/ClosedTenders", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ ...searchdate }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetClosedTenders:", error);
      }
    };

    const GetAuctionsList = async (type, searchPattern) => {
      try {
        let data = await fetch(apiurl + "/Admin/Auctions", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ type: type, searchPattern: searchPattern }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAuctionsList:", error);
      }
    };
    const EditAuction = async (formdata) => {
      try {
        let data = await fetch(apiurl + "/Admin/Auctions", {
          method: "POST",
          headers: { AuthToken: token },
          body: formdata,
        });
        data = await data.json();
        console.log(data);
        return data;
      } catch (error) {
        console.error("Error in EditAuction:", error);
      }
    };
    const CreateAuction = async (formdata, EToken) => {
      try {
        let data = await fetch(apiurl + "/Admin/CreateAuction", {
          method: "POST",
          headers: { AuthToken: token },
          body: formdata,
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in CreateAuction:", error);
      }
    };

    const AuctionWinnerDeclartionGet = async () => {
      try {
        let data = await fetch(apiurl + "/Admin/AuctionWinnerDeclartion", {
          method: "POST",
          headers: { AuthToken: token },
          body: {},
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in AuctionWinnerDeclartionGet:", error);
      }
    };

    const GetWinnerDeclare = async (id) => {
      try {
        let data = await fetch(apiurl + "/Admin/GetWinnerDeclare", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ id: id }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetWinnerDeclare:", error);
      }
    };

    const MakeWinner = async (formdata) => {
      try {
        let data = await fetch(apiurl + "/Admin/MakeWinner", {
          method: "POST",
          headers: { AuthToken: token },
          body: formdata,
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in MakeWinner:", error);
      }
    };
    const ReverseWinner = async (formdata) => {
      try {
        let data = await fetch(apiurl + "/Admin/ReverseWinner", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ ...formdata }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in ReverseWinner:", error);
      }
    };

    const WinnerCrudOperations = async (type, id, form) => {
      try {
        if (type === "GetData") {
          let data = await fetch(apiurl + "/Admin/WinnerCrudOperations", {
            method: "POST",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({ type: type, Auction_ID: id }),
          });
          data = await data.json();
          return data;
        }
        if (type === "update") {
          let data = await fetch(apiurl + "/Admin/WinnerCrudOperations", {
            method: "POST",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({
              type: type,
              ...form,
            }),
          });
          data = await data.json();
          return data;
        }
      } catch (error) {
        console.error("Error in WinnerCrudOperations:", error);
      }
    };

    const ShowAuctions = async (type, item) => {
      try {
        // if (item) {
        //     let data = await Axios.post('http://' + apiurl + '/GetAuctions/ShowAuctions', { type: type, searchPattern: item }, {
        //         headers: {
        //             'Content-Type': 'Application/json'
        //         }
        //     }).then(response => {
        //         return response.data
        //     }).catch(err => {
        //         console.log(err)
        //     })
        //     return data
        // }
        // let data = await Axios.post('http://' + apiurl + '/GetAuctions/ShowAuctions', { type: type }, {
        //     headers: {
        //         'Content-Type': 'Application/json'
        //     }
        // }).then(response => {
        //     return response.data
        // }).catch(err => {
        //     console.log(err)
        // })
        // return data
      } catch (error) {
        console.error("Error in ShowAuctions:", error);
      }
    };

    const EcsRefund = async (method) => {
      if (method === "LoserRefund") {
        try {
          let refund = await Axios.post(
            apiurl + "/Admin/EcsRefund",
            { method: method },
            {
              headers: {
                "Content-Type": "Application/json",
                AuthToken: token,
              },
            },
          )
            .then((response) => {
              return response.data;
            })
            .catch((e) => {
              console.log(e);
            });
          return refund;
        } catch (error) {
          console.error("Error in EcsRefund:", error);
        }
      }
      if (method === "TenderCancelRefund") {
        try {
          let refund = await Axios.post(
            apiurl + "/Admin/EcsRefund",
            { method: method },
            {
              headers: {
                "Content-Type": "Application/json",
                AuthToken: token,
              },
            },
          )
            .then((response) => {
              return response.data;
            })
            .catch((e) => {
              console.log(e);
            });
          return refund;
        } catch (error) {
          console.error("Error in EcsRefund:", error);
        }
      } else {
        try {
          let refund = await Axios.post(
            apiurl + "/Admin/EcsRefund",
            {},
            {
              headers: {
                "Content-Type": "Application/json",
                AuthToken: token,
              },
            },
          )
            .then((response) => {
              return response.data;
            })
            .catch((e) => {
              console.log(e);
            });
          return refund;
        } catch (error) {
          console.error("Error in EcsRefund:", error);
        }
      }
    };

    const GenerateRefund = async (type, Auctionid) => {
      try {
        let refund = await Axios.post(
          apiurl + "/Admin/GenerateRefund",
          { type: type, Auctionid: Auctionid },
          {
            headers: {
              "Content-Type": "Application/json",
              AuthToken: token,
            },
          },
        )
          .then((response) => {
            return response.data;
          })
          .catch((e) => {
            console.log(e);
          });
        return refund;
      } catch (error) {
        console.error("Error in GenerateRefund:", error);
      }
    };
    const EcsUpload = async (data, id, AuctionName) => {
      try {
        let refund = await Axios.post(
          apiurl + "/Admin/EcsUploadfile",
          {
            data: data,
            AuctionId: id,
            AuctionName: AuctionName,
          },
          {
            headers: {
              "Content-Type": "Application/json",
              AuthToken: token,
            },
          },
        )
          .then((response) => {
            return response.data;
          })
          .catch((e) => {
            console.log(e);
          });
        return refund;
      } catch (error) {
        console.error("Error in EcsUpload:", error);
      }
    };
    const ShowRegisteredAuctionUser = async (id) => {
      try {
        let refund = await Axios.post(
          apiurl + "/Admin/ShowRegisteredAuctionUser",
          {
            AuctionId: id,
          },
          {
            headers: {
              "Content-Type": "Application/json",
              AuthToken: token,
            },
          },
        )
          .then((response) => {
            console.log(response.data);
            return response.data;
          })
          .catch((e) => {
            console.log(e);
          });
        return refund;
      } catch (error) {
        console.error("Error in ShowRegisteredAuctionUser:", error);
      }
    };

    const CompleteRefundProcess = async (Auctionid) => {
      try {
        let refund = await Axios.post(
          apiurl + "/Admin/CompleteRefundProcess",
          {
            AuctionId: Auctionid,
          },
          {
            headers: {
              "Content-Type": "Application/json",
              AuthToken: token,
            },
          },
        )
          .then((response) => {
            return response.data;
          })
          .catch((e) => {
            console.log(e);
          });
        return refund;
      } catch (error) {
        console.error("Error in CompleteRefundProcess:", error);
      }
    };

    const SendRefund = async (Data, id, tendername, textToSave, EToken) => {
      try {
        let refund = await Axios.post(
          apiurl + "/AdminRefund/RefundHash",
          {
            csvdata: Data,
            Tender_ID: id,
            Tender_Name: tendername,
            textToSave: textToSave,
          },
          {
            headers: {
              "Content-Type": "Application/json",
              AuthToken: token,
              EToken: EToken,
            },
          },
        )
          .then((response) => {
            return response.data;
          })
          .catch((e) => {
            console.log(e);
          });
        return refund;
      } catch (error) {
        console.error("Error in SendRefund:", error);
      }
    };

    const EmployeeManagement = async (type, data) => {
      try {
        if (type === "Create") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/CreateEmployee",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({ ...data, type }),
            },
          );
          Creation = await Creation.json();
          return Creation;
        }
        if (type === "Update") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/CreateEmployee",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({ ...data, type }),
            },
          );
          Creation = await Creation.json();
          if (Creation) {
            alert("Successfully Edited");
          } else {
            alert("failed Edition");
          }
        } else if (type === "View") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/CreateEmployee",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({ Searchparameter: data, type: "View" }),
            },
          );
          Creation = await Creation.json();
          return Creation;
        } else if (type === "ViewProfile") {
      let response = await fetch(
        apiurl + "/EmployeeManagement/CreateEmployee",
        {
          method: "post",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ type: "ViewProfile" }),
        },
      );
      response = await response.json();
      return response;

    } else if (type === "UpdateProfile") {
      let response = await fetch(
        apiurl + "/EmployeeManagement/CreateEmployee",
        {
          method: "post",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ ...data, type: "UpdateProfile" }),
        },
      );
      response = await response.json();
      return response;
    }
      } catch (error) {
        console.error("Error in EmployeeManagement:", error);
      }
    };

    const Roles = async (type, data, obj) => {
      try {
        if (type === "View") {
          let Creation = await fetch(apiurl + "/EmployeeManagement/Roles", {
            method: "post",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({ type: "View" }),
          });
          Creation = await Creation.json();
          return Creation;
        } else if (type === "CreateRole") {
          let Creation = await fetch(apiurl + "/EmployeeManagement/Roles", {
            method: "post",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({ ...data, type: "CreateRole", obj }),
          });
          Creation = await Creation.json();
          console.log(Creation);
          if (Creation) {
            alert("Your Role has been Successfully Created");
          }
          return Creation;
        }
      } catch (error) {
        console.error("Error in Roles:", error);
      }
    };

    const DepartmentHandler = async (type, data, obj) => {
      try {
        if (type === "view") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/Department",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({ type: "view" }),
            },
          );
          Creation = await Creation.json();
          return Creation;
        } else if (type === "insert") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/Department",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({
                Department_Name: data,
                type: type,
                Menu_Access: obj,
              }),
            },
          );
          Creation = await Creation.json();
          if (Creation) {
            alert("Your Department has been Successfully Created");
          }
          return Creation;
        } else if (type === "delete") {
          let Creation = await fetch(
            apiurl + "/EmployeeManagement/Department",
            {
              method: "post",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({
                Department_Name: data,
                type: type,
              }),
            },
          );
          Creation = await Creation.json();
          if (Creation) {
            alert("Department Deleted Successfully");
          } else {
            alert("Failed to Delete Department");
          }
          return Creation;
        }
      } catch (error) {
        console.error("Error in DepartmentHandler:", error);
      }
    };

    const EditRoleActions = async (type, RoleID, menu, menuset) => {
      try {
        let Creation = await fetch(apiurl + "/EmployeeManagement/EditRole", {
          method: "post",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ type: type, RoleID: RoleID, menu, menuset }),
        });
        Creation = await Creation.json();
        if (Creation === true) {
          alert("Your Role Editation has been complete");
        }
        return Creation;
      } catch (error) {
        console.error("Error in EditRoleActions:", error);
      }
    };

    const MisReports = async (obj) => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/MisReports", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify(obj),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.log(error);
      }
    };
    const CustomeReports = async (form) => {
      try {
        let data = await fetch(apiurl + "/GetAuctions/CustomeReports", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ ...form }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in CustomeReports:", error);
      }
    };
    const WinnerRefund = async (form, EToken) => {
      console.log(form);
      console.log(EToken);

      try {
        let data = await fetch(apiurl + "/Admin/TenderWinnerRefund", {
          method: "POST",
          headers: { AuthToken: token, EToken: EToken },
          body: form,
        });
        data = await data.json();
        console.log("data", data);
        return data;
      } catch (error) {
        console.error("Error in WinnerRefund:", error);
      }
    };

    const DashboardReports = async (daterep) => {
      try {
        let data = await fetch(apiurl + "/GetAuctions/DashboardReports", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ date: daterep }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in DashboardReports:", error);
      }
    };

    const CreateToken = async (fortoken) => {
      try {
        let data = await fetch(apiurl + "/Signature/CreateToken", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ fortoken: fortoken }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in CreateToken:", error);
      }
    };

    const AuthorizationFiles = async (fortoken) => {
      try {
        let data = await fetch(apiurl + "/Signature/Authorization", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ fortoken: fortoken }),
        });
        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in AuthorizationFiles:", error);
      }
    };

    const Authorizationverify = async (Tender_ID, EToken) => {
      try {
        let data = await fetch(apiurl + "/Signature/Authorizationverify", {
          method: "POST",
          headers: {
            "Content-Type": "Application/json",
            AuthToken: token,
            EToken: EToken,
          },
          body: JSON.stringify({ Tender_ID: Tender_ID }),
        });
        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in Authorizationverify:", error);
      }
    };

    const Authorizationreject = async (Tender_ID, EToken, Remark) => {
      try {
        let data = await fetch(apiurl + "/Signature/Authorizationreject", {
          method: "POST",
          headers: {
            "Content-Type": "Application/json",
            AuthToken: token,
            EToken: EToken,
          },
          body: JSON.stringify({ Tender_ID: Tender_ID, Remark: Remark }),
        });
        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in Authorizationreject:", error);
      }
    };

    const ReUploadDocument = async (formdata) => {
      try {
        let data = await fetch(apiurl + "/Signature/ReUploadDocument", {
          method: "POST",
          headers: { AuthToken: token },
          body: formdata,
        });
        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in ReUploadDocument:", error);
      }
    };

    const ReUploadCancelDocument = async (formdata) => {
      try {
        let data = await fetch(apiurl + "/Signature/ReUploadCancelDocument", {
          method: "POST",
          headers: { AuthToken: token },
          body: formdata,
        });
        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in ReUploadCancelDocument:", error);
      }
    };

    const ApprovalRefund = async (Tender_ID) => {
      try {
        let data = await fetch(apiurl + "/AdminRefund/ApprovalRefund", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ Tender_ID: Tender_ID }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in ApprovalRefund:", error);
      }
    };

    const GetVendors = async (UniqueID) => {
      try {
        if (UniqueID) {
          let data = await fetch(
            apiurl + "/VendorManagement/GetAllContractorList",
            {
              method: "POST",
              headers: { "Content-Type": "Application/json", AuthToken: token },
              body: JSON.stringify({ UniqueID }),
            },
          );
          data = await data.json();
          return data;
        } else {
          let data = await fetch(
            apiurl + "/VendorManagement/GetAllContractorList",
            {
              method: "POST",
              headers: { AuthToken: token },
            },
          );
          data = await data.json();
          return data;
        }
      } catch (error) {
        console.error("Error in GetVendors:", error);
      }
    };
    const GetReport = async () => {
      console.log("called");

      try {
        let data = await fetch(apiurl + "/GetReport", {
          method: "GET",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetReport:", error);
      }
    };

    const AddBudget = async (Head, Fund, Approvals) => {
      try {
        let data = await fetch(apiurl + "/AddBudget", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ Head, Fund, Approvals }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in AddBudget:", error?.message || error);
      }
    };

    const GetBudget = async () => {
      try {
        let data = await fetch(apiurl + "/GetBudget", {
          method: "GET",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetBudget:", error?.message || error);
      }
    };

    const UpdateBudget = async (id, updatedData) => {
      console.log(updatedData);

      try {
        let data = await fetch(`${apiurl}/UpdateBudget`, {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify(updatedData),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in UpdateBudget:", error?.message || error);
      }
    };

    const DeleteBudget = async (id) => {
      console.log(id);

      try {
        let data = await fetch(`${apiurl}/DeleteBudget`, {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ id }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in DeleteBudget:", error?.message || error);
      }
    };

    const BankMaster = async (type, formData) => {
      console.log("swapnil", type, formData);

      try {
        if (type == "get") {
          let Creation = await fetch(apiurl + "/banks", {
            method: "post",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({ type: "get" }),
          });
          Creation = await Creation.json();
          return Creation;
        } else if (type == "insert") {
          let Creation = await fetch(apiurl + "/banks", {
            method: "post",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({
              ...formData,
              type: type,
            }),
          });
          Creation = await Creation.json();
          return Creation;
        } else if (type == "edit") {
          let Creation = await fetch(apiurl + "/banks", {
            method: "post",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({
              ...formData,
              type: type,
            }),
          });
          Creation = await Creation.json();
          return Creation;
        } else if (type == "delete") {
          let Creation = await fetch(apiurl + "/banks", {
            method: "post",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({
              id: formData,
              type: type,
            }),
          });
          Creation = await Creation.json();
          return Creation;
        }
      } catch (error) {
        console.error("Error in BankMaster:", error);
      }
    };

    const UploadBills = async (formdata) => {
      console.log(formdata);

      try {
        let data = await fetch(apiurl + "/VendorManagement/UploadBill", {
          method: "POST",
          headers: { AuthToken: token },
          body: formdata,
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in UploadBills:", error);
      }
    };
    const TaxData = async (type, formdata) => {
      console.log("Formdata111", type, formdata);

      try {
        if (type === "get") {
          let Creation = await fetch(apiurl + "/Taxes", {
            method: "post",
            headers: { "Content-type": "Application/json", AuthToken: token },
            body: JSON.stringify({ type: "get" }),
          });
          Creation = await Creation.json();
          return Creation;
        } else if (type === "insert") {
          console.log("insert");

          let Creation = await fetch(apiurl + "/Taxes", {
            method: "post",
            headers: { "Content-type": "Application/json", AuthToken: token },
            body: JSON.stringify({
              ...formdata,
              type: type,
            }),
          });
          Creation = await Creation.json();
          return Creation;
        } else if (type === "edit") {
          console.log("edit");
          let Creation = await fetch(apiurl + "/Taxes", {
            method: "post",
            headers: { "Content-type": "Application/json", AuthToken: token },
            body: JSON.stringify({ ...formdata, type: type }),
          });
          Creation = await Creation.json();
          return Creation;
        } else if (type === "delete") {
          console.log("delete");
          let Creation = await fetch(apiurl + "/taxes", {
            method: "post",
            headers: { "Content-type": "Application/json", AuthToken: token },
            body: JSON.stringify({ type: type, ID: formdata }),
          });
          Creation = await Creation.json();
          return Creation;
        }
      } catch (error) {
        console.error("Error in TaxData:", error);
        return { message: "failed", error };
      }
    };

    const GetBills = async () => {
      try {
        let data = await fetch(apiurl + "/BillApprovals/GetBills", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetBills:", error);
      }
    };

    const ApproveBills = async (selectedBills, type, remark) => {
      try {
        const response = await fetch(apiurl + "/BillApprovals/ApproveBills", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
          body: JSON.stringify({
            selectedBills,
            type,
            remark,
          }),
        });

        console.log("Status:", response.status);

        const result = await response.json();
        console.log("Response:", result);

        return result;
      } catch (error) {
        console.error("ApproveBills Error:", error);
        throw error;
      }
    };

    const GetVendorBills = async () => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/GetVendorBills", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetVendorBills:", error);
      }
    };

    // const GetTaxAmounts = async (type) => {
    //   try {
    //     let data = await fetch(apiurl + "/Dashboard/getTaxesAmount", {
    //       method: "POST",
    //       headers: { AuthToken: token },
    //     });
    //     data = await data.json();
    //     return data;
    //   } catch (error) {
    //     console.error("Error in getTaxes:", error);
    //   }
    // };

    const GetTaxAmounts = async (scheme = "") => {
      try {
        let data = await fetch(apiurl + "/Dashboard/getTaxesAmount", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
          body: JSON.stringify({
            scheme,
          }),
        });

        data = await data.json();

        return data;
      } catch (error) {
        console.error("Error in getTaxes:", error);
        return {};
      }
    };

    const getTaxes = async () => {
      try {
        let data = await fetch(apiurl + "/getTaxes", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in getTaxes:", error);
      }
    };

    const GetAgnecyWiseTaxAmount = async (type) => {
      try {
        let data = await fetch(apiurl + "/Dashboard/getAgnecyWiseTaxAmount", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in getTaxes:", error);
      }
    };

    const GetAgencyWiseData = async (projectId, type) => {
      try {
        let data = await fetch(apiurl + "/Dashboard/getAgencyWiseData", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ projectId: projectId, type: type }),
        });
        let res = await data.json();
        return res;
      } catch (error) {
        console.error("Error in GetAgencyWiseData:", error);
      }
    };
    const getTaxAmountsByDate = async () => {
      try {
        let data = await fetch(apiurl + "/Dashboard/getTaxesAmountbyDate", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in getTaxAmounts:", error);
      }
    };

    const GetLogReports = async () => {
      try {
        let data = await fetch(apiurl + "/GetLogReports", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetRefundFiles:", error);
      }
    };
    const GetSteelRates = async () => {
      try {
        let data = await fetch(apiurl + "/GetSteelRates", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetSteelRates:", error);
      }
    };

    const GetDateWiseData = async (projectId, type) => {
      try {
        let data = await fetch(apiurl + "/Dashboard/getDateWiseData", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ projectId: projectId, type: type }),
        });
        let res = await data.json();
        return res;
      } catch (error) {
        console.error("Error in GetDateWiseData:", error);
      }
    };

    const AddProduct = async (type, formData) => {
      try {
        if (type === "get") {
          let response = await fetch(apiurl + "/Inventory/add_product", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({ type: "get" }),
          });
          const data = await response.json();
          return data;
        }

        if (type === "insert") {
          let response = await fetch(apiurl + "/Inventory/add_product", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({ ...formData, type }),
          });
          const data = await response.json();
          return data;
        }

        if (type === "update") {
          let response = await fetch(apiurl + "/Inventory/add_product", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({ ...formData, type: "update" }),
          });
          const data = await response.json();
          return data;
        }

        if (type === "delete") {
          let response = await fetch(apiurl + "/Inventory/add_product", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({ ID: formData.ID, type: "delete" }),
          });
          const data = await response.json();
          return data;
        }

        return { message: "invalid request" };
      } catch (error) {
        console.error("Error in AddProduct:", error);
        return { message: "failed", error };
      }
    };
    const PurchaseList = async (type, formData) => {
      try {
        if (type === "get") {
          let response = await fetch(apiurl + "/Inventory/PurchaseList", {
            method: "POST",
            headers: { "content-type": "application/json", AuthToken: token },
            body: JSON.stringify({ type: "get" }),
          });
          const data = await response.json();
          return data;
        }

        if (type === "insert") {
          let response = await fetch(apiurl + "/Inventory/PurchaseList", {
            method: "POST",
            headers: { "content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ ...formData, type }),
          });
          const data = await response.json();
          return data;
        }
        if (type === "update") {
          let response = await fetch(apiurl + "/Inventory/PurchaseList", {
            method: "POST",
            headers: { "content-type": "application/json", AuthToken: token },
            body: JSON.stringify({ ...formData, type }),
          });
          const data = await response.json();
          return data;
        }
        if (type === "delete") {
          let response = await fetch(apiurl + "/Inventory/PurchaseList", {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ ID: formData.ID, type: "delete" }),
          });
          const data = await response.json();
          return data;
        }
        return { message: "invalid request" };
      } catch (error) {
        return { message: "failed", error };
      }
    };
    const getecsreponsefiles = async () => {
      try {
        let data = await fetch(apiurl + "/BillApprovals/GetEcsReposnseFiles", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in ProjectCreation:", error);
        throw error;
      }
    };

    const HeadCreation = async (forminf) => {
      try {
        let response = await fetch(
          `${apiurl}/VendorManagement/BudgetHeadCreation`,
          {
            method: "POST",
            headers: { AuthToken: token },
            body: forminf,
          },
        );
        let data = await response.json();
        return data;
      } catch (error) {
        console.error("Error in HeadCreation:", error);
        throw error;
      }
    };

    const GetProjectInfo = async (ProjectID, type) => {
      try {
        let data = await fetch(`${apiurl}/VendorManagement/GetProjectInfo`, {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ ProjectID: ProjectID, type: type }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProjectInfo:", error);
      }
    };

    const DeductionOperation = async (deductionData, type) => {
      try {
        let data = await fetch(
          `${apiurl}/VendorManagement/DeductionOperation`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ deductionData: deductionData, type: type }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in DeductionOperation:", error);
      }
    };

    // const GetBudgetHeadInfo = async (HeadID, type, selectedDemandID = null) => {
    //   try {
    //     let data = await fetch(`${apiurl}/VendorManagement/GetBudgetHeadInfo`, {
    //       method: "POST",
    //       headers: { "Content-Type": "application/json", AuthToken: token },
    //       body: JSON.stringify({
    //         HeadID: HeadID,
    //         type: type,
    //         selectedDemandID: selectedDemandID,
    //       }),
    //     });
    //     data = await data.json();
    //     return data;
    //   } catch (error) {
    //     console.error("Error in GetBudgetHeadInfo:", error);
    //   }
    // };


        // 27-10 for progress report 
        
    const GetBudgetHeadInfo = async (
      HeadID,
      type,
      selectedDemandID,
      ProjectId = null
    ) => {
      try {
        const requestBody = {
          HeadID,
          type,
          selectedDemandID,
          ProjectId,
        };
    
        console.log("GetBudgetHeadInfo Request Body:", requestBody);
    
        const response = await fetch(
          `${apiurl}/VendorManagement/GetBudgetHeadInfo`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify(requestBody),
          }
        );
    
        const data = await response.json();
    
        console.log("GetBudgetHeadInfo Response:", data);
    
        return data;
      } catch (error) {
        console.error("Error in GetBudgetHeadInfo:", error);
        return null;
      }
    };
    
    const WorkOrderCreation = async (formData) => {
      try {
        let response = await fetch(
          `${apiurl}/VendorManagement/WorkOrderCreation`,
          {
            method: "POST",
            headers: { AuthToken: token },
            body: formData,
          },
        );
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error in WorkOrderCreation:", error);
        throw error;
      }
    };

    const BudgetEstimation = async (forminf) => {
      try {
        let res = await fetch(`${apiurl}/VendorManagement/BudgetEstimation`, {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify(forminf),
        });
        const data = await res.json();
        return data;
      } catch (err) {
        console.log(err);
      }
    };

     const DemandCreation = async (forminf) => {
          console.log("DemandGeneration Called");
          try {
            let response = await fetch(
              `${apiurl}/VendorManagement/DemandGeneration`,
              {
                method: "POST",
                headers: { AuthToken: token },
                body: forminf,
              },
            );
    
            const data = await response.json();
            return data;
          } catch (error) {
            console.error("Error in WorkOrderCreation:", error);
            throw error;
          }
        };

    const ReleaseFDUTF = async (formData) => {
      try {
        let response = await fetch(`${apiurl}/VendorManagement/ReleaseFDUTF`, {
          method: "POST",
          headers: { AuthToken: token },
          body: formData,
        });
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error in ProjectCreation:", error);
        throw error;
      }
    };

    const ViewAllReleaseFDUTF = async () => {
      try {
        let response = await fetch(
          `${apiurl}/VendorManagement/ViewAllReleaseFDUTF`,
          {
            method: "POST",
            headers: { AuthToken: token },
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Parse the response body
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Fetch error:", error);
        throw error;
      }
    };

    const GetDemandApproval = async () => {
      try {
        let data = await fetch(`${apiurl}/VendorManagement/GetDemandApproval`, {
          method: "GET",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetOpenTenders:", error);
      }
    };

    const GetAllProjectList = async () => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/GetAllProjectList", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllProjectList:", error);
      }
    };

    const GetAllContractorList = async () => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetAllContractorList",
          {
            method: "POST",
            headers: { AuthToken: token },
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllProjectList:", error);
      }
    };

    const GetAllBudgetHeadList = async () => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetAllBudgetHeadList",
          {
            method: "POST",
            headers: { AuthToken: token },
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllProjectList:", error);
      }
    };

    const GetAllBudgetEstimationList = async () => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetAllBudgetEstimationList",
          {
            method: "POST",
            headers: { AuthToken: token },
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllProjectList:", error);
      }
    };

    const GetAllWorkOrderList = async () => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetAllWorkOrderList",
          {
            method: "POST",
            headers: { AuthToken: token },
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllProjectList:", error);
      }
    };

    const GetProjectTotal = async () => {
      try {
        let data = await fetch(apiurl + "/Dashboard/getTotalProject", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProjectTotal:", error);
      }
    };
    const GetTotalAmountAvailbaleInBank = async () => {
      try {
        let data = await fetch(apiurl + "/Dashboard/getTotalBalanceinBank", {
          method: "POST",
          headers: { AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProjectTotal:", error);
      }
    };
    const GetLiabilityTotal = async (type) => {
      try {
        let data = await fetch(apiurl + "/Dashboard/GetTotalLiabilities", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ type: type }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProjectTotal:", error);
      }
    };

    const FundAllomentOperation = async (type, formdata) => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/FundAllotment", {
          method: "POST",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ type: type, data: formdata }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProjectTotal:", error);
      }
    };

    const ProjectCreation = async (forminf) => {
      try {
        let response = await fetch(`${apiurl}/VendorManagement/CreateProject`, {
          method: "POST",
          headers: { AuthToken: token },
          body: forminf,
        });
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error in ProjectCreation:", error);
        throw error;
      }
    };
    const GetObjectCodes = async () => {
      const response = await fetch(
        `${apiurl}/VendorManagement/getObjectCodes`,
        {
          method: "GET",
          headers: { AuthToken: token },
        },
      ); // Adjust the endpoint as needed

      if (!response.ok) {
        throw new Error("Failed to fetch object codes");
      }
      return response.json();
    };

    // ✅ New Add function
    const AddObjectCode = async (objectCode) => {
      const response = await fetch(`${apiurl}/VendorManagement/addObjectCode`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          AuthToken: token,
        },
        body: JSON.stringify({ objectCode }),
      });

      if (!response.ok) {
        throw new Error("Failed to add object code");
      }

      return response.json(); // Optionally return server response
    };
    const UpdateObjectCode = async (oldCode, objectCode) => {
      const response = await fetch(
        `${apiurl}/VendorManagement/updateObjectCode`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
          body: JSON.stringify({
            oldObjectCode: oldCode,
            newObjectCode: objectCode,
          }),
        },
      );

      if (!response.ok) throw new Error("Failed to update object code");
      return response.json();
    };

    const DeleteObjectCode = async (id) => {
      const response = await fetch(
        `${apiurl}/VendorManagement/deleteObjectCode`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
          body: JSON.stringify({ id }),
        },
      );

      if (!response.ok) throw new Error("Failed to delete object code");
      return response.json();
    };

    const GetTotalEstimationForWorkOrder = async (
      ProjectID,
      BudgetHeadID,
      type,
    ) => {
      try {
        let data = await fetch(
          `${apiurl}/VendorManagement/GetTotalEstimationForWorkOrder`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthToken: token,
            },
            body: JSON.stringify({
              ProjectID,
              BudgetHeadID,
              type,
            }),
          },
        );

        data = await data.json();
        return data.total;
      } catch (error) {
        console.error("Error:", error);
      }
    };

    const BudgetHeadApproval = async (id, type, remark) => {
      try {
        let data = await fetch(apiurl + "/BillApprovals/BudgetHeadApproval", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ id: id, type: type, remark: remark }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in BudgetHeadApproval:", error);
      }
    };

    const GetBudgetHeadList = async () => {
      try {
        let data = await fetch(apiurl + "/BillApprovals/GetBudgetHeadList", {
          method: "GET",
          headers: { "Content-Type": "application/json", AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetBudgetHeadList:", error);
      }
    };

    const ProjectApproval = async (id, type, remark) => {
      try {
        let data = await fetch(apiurl + "/BillApprovals/ProjectApproval", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ id: id, type: type, remark: remark }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in ProjectApproval:", error);
      }
    };

    const GetProjectList = async () => {
      try {
        let data = await fetch(apiurl + "/BillApprovals/GetProjectList", {
          method: "GET",
          headers: { "Content-Type": "application/json", AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetProjectList:", error);
      }
    };

    const BudgetEstimationApproval = async (id, type, remark) => {
      try {
        let data = await fetch(
          apiurl + "/BillApprovals/BudgetEstimationApproval",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ id: id, type: type, remark: remark }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in BudgetEstimationApproval:", error);
      }
    };

    const GetBudgetEstimationList = async () => {
      try {
        let data = await fetch(
          apiurl + "/BillApprovals/GetBudgetEstimationList",
          {
            method: "GET",
            headers: { "Content-Type": "application/json", AuthToken: token },
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetBudgetEstimationList:", error);
      }
    };

    const ReleaseFromFinanceApproval = async (id, type, remark) => {
      try {
        let data = await fetch(
          apiurl + "/BillApprovals/ReleaseFromFinanceApproval",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ id: id, type: type, remark: remark }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in ReleaseFromFinanceApproval:", error);
      }
    };

    const GetReleaseFromFinanceList = async () => {
      try {
        let data = await fetch(
          apiurl + "/BillApprovals/GetReleaseFromFinanceList",
          {
            method: "GET",
            headers: { "Content-Type": "application/json", AuthToken: token },
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetReleaseFromFinanceList:", error);
      }
    };

    const GetAllWorkOrderInward = async () => {
      try {
        let res = await fetch(`${apiurl}/BillApprovals/GetAllWorkOrderInward`, {
          method: "GET",
          headers: { "Content-Type": "application/json", AuthToken: token },
        });
        let data = await res.json();
        return data;
      } catch (error) {
        console.log(error);
      }
    };

    const WorkManagementApproval = async (id, type, remark) => {
      try {
        let data = await fetch(
          apiurl + "/BillApprovals/WorkManagementApproval",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ id: id, type: type, remark: remark }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in WorkManagementApproval:", error);
      }
    };

    const GetVendorBillsAndDeduction = async (DemandID) => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetVendorBillsAndDeduction",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({ DemandID: DemandID }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetVendorBillsAndDeduction:", error);
      }
    };

    const AgencyRegistration = async (AgencyData) => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/AgencyRegistration",
          {
            method: "POST",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({ data: AgencyData }),
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in AgencyRegistration:", error);
      }
    };

    const GetAgencyList = async () => {
      try {
        let data = await fetch(apiurl + "/VendorManagement/GetAllAgencyList", {
          method: "GET",
          headers: { "Content-Type": "application/json", AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAgencyList:", error);
      }
    };

    const CreateUser = async (type, data) => {
      try {
        let data = await fetch(apiurl + "/EmployeeManagement/CreateUser", {
          method: "post",
          headers: { "Content-Type": "Application/json", AuthToken: token },
          body: JSON.stringify({ ...data, type }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in EmployeeManagement:", error);
      }
    };

    const GetAllFundList = async () => {
      try {
        let data = await fetch(apiurl + "/BillApprovals/GetAllFundList", {
          method: "GET",
          headers: { "Content-Type": "application/json", AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetAllFundList:", error);
      }
    };
    const FetchECSFiles = async () => {
      const res = await fetch(apiurl + "/ECSReport/FetchECSFiles", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          AuthToken: token,
        },
      });
      return res.json();
    };
    const FetchECSFilesForTransfer = async () => {
      const res = await fetch(apiurl + "/ECSReport/FetchECSFilesForTransfer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          AuthToken: token,
        },
      });
      return res.json();
    };

    const FetchECSReport = async (FileName) => {
      try {
        let data = await fetch(apiurl + "/ECSReport/FetchECSReport", {
          method: "POST",
          headers: { "Content-Type": "Application/Json", AuthToken: token },
          body: JSON.stringify({ fileName: FileName }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("error in FetchECSReport:", error);
      }
    };

    const FetchECSDashboardReport = async (FileName) => {
      try {
        let data = await fetch(apiurl + "/ECSReport/FetchECSDashboardReport", {
          method: "GET",
          headers: { "Content-Type": "Application/Json", AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("error in FetchECSDashboardReport:", error);
      }
    };

    const FetchFilesForUpdate = async (FileName) => {
      try {
        let data = await fetch(apiurl + "/ECSReport/FetchFilesForUpdate", {
          method: "GET",
          headers: { "Content-Type": "Application/Json", AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("error in FetchFilesForUpdate:", error);
      }
    };

    const FundCreation = async (formdata) => {
      try {
        let response = await fetch(`${apiurl}/VendorManagement/FundCreation`, {
          method: "POST",
          headers: { AuthToken: token },
          body: formdata,
        });
        return await response.json();
        // return data;
      } catch (error) {
        console.error("Error in FundCreation:", error);
        throw error;
      }
    };

    const FundApproval = async (id, type, remark) => {
      console.log("calledddd");

      try {
        let data = await fetch(apiurl + "/BillApprovals/FundApproval", {
          method: "POST",
          headers: { "Content-Type": "application/json", AuthToken: token },
          body: JSON.stringify({ id: id, type: type, remark: remark }),
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in FundApproval:", error);
      }
    };

    const GetNewFundList = async () => {
      try {
        let data = await fetch(apiurl + "/BillApprovals/GetNewFundList", {
          method: "GET",
          headers: { "Content-Type": "application/json", AuthToken: token },
        });
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetFundList:", error);
      }
    };

    const GetNewFundOutwardList = async () => {
      try {
        let data = await fetch(
          apiurl + "/VendorManagement/GetNewFundOutwardList",
          {
            method: "GET",
            headers: { "Content-Type": "application/json", AuthToken: token },
          },
        );
        data = await data.json();
        return data;
      } catch (error) {
        console.error("Error in GetNewFundOutwardList:", error);
      }
    };
    const CreateMapCoordinateforProject = async (type, formdata) => {
      const response = await fetch(
        `${apiurl}/VendorManagement/MapCoordinateforProject`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            AuthToken: token,
          },
          body: JSON.stringify({ type, formdata }),
        },
      );
      console.log("Status :", response.status);
      console.log("URL :", response.url);

      const text = await response.text();

      console.log("Response Text :", text);

      try {
        return JSON.parse(text);
      } catch (err) {
        console.log("Invalid JSON Response");
        throw err;
      }
    };
    const GetProgressReportList = async () => {
      try {
        const response = await fetch(
          `${apiurl}/VendorManagement/GetProgressReportList`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json", AuthToken: token },
          },
        );
        const result = await response.json();
        return result;
      } catch (error) {
        console.log("GetProgressReportList Error :", error);
        return {
          Status: false,
          Message: "Server Error",
        };
      }
    };
    //
    const ApproveProgressReport = async (ids, type, remark) => {
      try {
        const response = await fetch(
          `${apiurl}/VendorManagement/ApproveProgressReport`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({
              IDs: ids,
              type: type,
              Remark: remark,
            }),
          },
        );

        const result = await response.json();
        return result;
      } catch (error) {
        console.log("ApproveProgressReport Error :", error);
        return { Status: false, Message: "Server Error" };
      }
    };

    const GetProgressReportOutwardList = async () => {
      try {
        const response = await fetch(
          `${apiurl}/VendorManagement/GetProgressReportOutwardList`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: sessionStorage.getItem("token"),
              AuthToken: token,
            },
          },
        );

        const result = await response.json();

        return result;
      } catch (error) {
        console.log("GetProgressReportList Error :", error);

        return {
          Status: false,
          Message: "Server Error",
        };
      }
    };

    const GetAgencyDashboardData = async ({
      agencyCode,
      projectId,
      type,
      workOrderUID,
    }) => {
      try {
        const response = await fetch(
          apiurl + "/Dashboard/GetAgencyDashboardData",
          {
            method: "POST",
            headers: { "Content-Type": "Application/json", AuthToken: token },
            body: JSON.stringify({ agencyCode, projectId, type, workOrderUID }),
          },
        );
        const result = await response.json();
        console.log("GetAgencyDashboardData RESPONSE:", result);
        if (!result.success) {
          console.error("GetAgencyDashboardData:", result.message);
          return [];
        }
        return result.data || [];
      } catch (error) {
        console.error("GetAgencyDashboardData ERROR:", error);
        return [];
      }
    };

    const GetProjectDashboardData = async (
      projectId,
      type,
      workOrderUID = "",
      scheme = "",
      schemeProjectIds = [],
    ) => {
      try {
        console.log("api called projectdashboard");
        const response = await fetch(
          apiurl + "/Dashboard/GetProjectDashboardData",
          {
            method: "POST",
            headers: {
              "Content-Type": "Application/json",
              AuthToken: token,
            },
            body: JSON.stringify({
              projectId,
              type,
              workOrderUID,
              scheme,
              schemeProjectIds,
            }),
          },
        );

        return await response.json();
      } catch (error) {
        console.error("GetProjectDashboardData ERROR:", error);
        return [];
      }
    };

    return (
      <Application.Provider
        value={{
          GetProjectDashboardData,
          GetAgencyDashboardData,
          GetAgencyWiseData,
          GetAgnecyWiseTaxAmount,
          ApprovalRefund,
          Authorizationverify,
          Authorizationreject,
          CreateToken,
          DashboardReports,
          WinnerRefund,
          CustomeReports,
          MisReports,
          Roles,
          EmployeeManagement,
          SendRefund,
          ReverseWinner,
          RefundTaxData,
          CompleteRefundProcess,
          GenerateRefund,
          EcsRefund,
          ShowAuctions,
          WinnerCrudOperations,
          MakeWinner,
          GetWinnerDeclare,
          AuctionWinnerDeclartionGet,
          EditAuction,
          Usermenu,
          SearchWinner,
          Organisation,
          GetPaymentTable,
          GetBillFiles,
          GetAdminPassKeys,
          AddAdminPassKeys,
          DeleteAdminPassKeys,
          GetOpenTenders,
          GetClosedTenders,
          GetAuctionsList,
          CreateAuction,
          EcsUpload,
          ShowRegisteredAuctionUser,
          DepartmentHandler,
          EditRoleActions,
          AuthorizationFiles,
          ReUploadDocument,
          ReUploadCancelDocument,
          GetVendors,
          GetReport,
          AddBudget,
          GetBudget,
          BankMaster,
          UploadBills,
          GetBills,
          ApproveBills,
          GetVendorBills,
          TaxData,
          UpdateBudget,
          DeleteBudget,
          GetTaxAmounts,
          getTaxes,
          getTaxAmountsByDate,
          GetLogReports,
          GetSteelRates,
          GetDateWiseData,
          AddProduct,
          PurchaseList,
          ProjectCreation,
          HeadCreation,
          GetProjectInfo,
          GetBudgetHeadInfo,
          WorkOrderCreation,
          BudgetEstimation,
          DemandCreation,
          ReleaseFDUTF,
          ViewAllReleaseFDUTF,
          GetDemandApproval,
          GetAllProjectList,
          GetAllContractorList,
          GetAllBudgetHeadList,
          GetAllBudgetEstimationList,
          GetAllWorkOrderList,
          GetProjectTotal,
          GetLiabilityTotal,
          GetTotalAmountAvailbaleInBank,
          FundAllomentOperation,
          DeductionOperation,
          GetObjectCodes,
          AddObjectCode,
          UpdateObjectCode,
          DeleteObjectCode,
          GetTotalEstimationForWorkOrder,
          GetAllWorkOrderInward,
          WorkManagementApproval,
          BudgetHeadApproval,
          GetBudgetHeadList,
          ProjectApproval,
          GetProjectList,
          BudgetEstimationApproval,
          GetBudgetEstimationList,
          ReleaseFromFinanceApproval,
          GetReleaseFromFinanceList,
          GetVendorBillsAndDeduction,
          AgencyRegistration,
          GetAgencyList,
          CreateUser,
          GetAllFundList,
          FetchECSFiles,
          FetchECSReport,
          FetchECSDashboardReport,
          FetchFilesForUpdate,
          FetchECSFilesForTransfer,
          FundCreation,
          FundApproval,
          GetNewFundList,
          GetNewFundOutwardList,
          CreateMapCoordinateforProject,
          GetProgressReportList,
          ApproveProgressReport,
          GetProgressReportOutwardList,
        }}
      >
        {props.children}
      </Application.Provider>
    );
  } catch (error) {
    console.error("Error in AdminState:", error);
    throw error;
  }
};
export default AdminState;
